import { getCookie } from './cookie';

export type IframeTheme = 'light' | 'dark';

const isTheme = (theme?: string | null): theme is IframeTheme =>
  theme === 'light' || theme === 'dark';

export const getIframeTheme = (fallback: IframeTheme = 'dark'): IframeTheme => {
  if (typeof window !== 'undefined') {
    const pageTheme = document.documentElement.dataset.theme;
    const storedTheme = getCookie('themeType');

    if (isTheme(pageTheme)) return pageTheme;
    if (isTheme(storedTheme)) return storedTheme;
  }

  return fallback;
};

export const setIframeQuery = (
  url: URL,
  lang: string,
  themeType: IframeTheme = getIframeTheme()
): URL => {
  url.searchParams.set('lang', lang);
  url.searchParams.set('themeType', themeType);

  return url;
};
